import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';

import { Alert, Autocomplete, Box, Card, CircularProgress, FormControl, Grid, MenuItem, Select, TextField } from '@mui/material';
import axiosInstance from '../../api/axiosInstance';
import moment from 'moment/moment';
import { set } from 'lodash';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});



const NewDevice = ({ setOpen, getData, toEditRow, setToEditRow, business, user, password, setSnackbarMsgType, setOpenSnackBar, serverExist }) => {

    const [editMode, setEditMode] = useState(false)
    const [currentQueues, setCurrentQueues] = useState([])
    const [connectedDevices, setConnectedDevices] = useState([])
    const [currentWoltVenues, setWoltVenues] = useState([]);
    const [selectedQueue, setSelectedQueue] = useState("")
    const [selectedWoltVenue, setSelectedWoltVenue] = useState("")
    const [selectedDevices, setSelectedDevices] = useState([])


    const getCurrentQeueus = async () => {
        try {
            const res = await axiosInstance.get(`/devices/queue/${business}`)
            setCurrentQueues(res.data)
        } catch (err) {
            console.log(err)
        }
    }

    const getConnectedDevices = async () => {
        try {
            const res = await axiosInstance.get(`/devices/connect/${business}`)
            setConnectedDevices(res.data.devices)
        } catch (error) {
            console.log(error)
        }
    }

    const getCurrentWoltVenues = async () => {
        try {
            const res = await axiosInstance.get("/wolt/venues")
            setWoltVenues(res.data);
        }
        catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        getCurrentQeueus()
        getCurrentWoltVenues()
        getConnectedDevices()
    }, [])

    const handleClose = () => {
        setOpen(false);
    };
    const [deviceCode, setDeviceCode] = useState("");//HelpdeskCid
    const [helpdeskCid, setHelpdeskCid] = useState("");//HelpdeskCid
    const [deviceId, setDeviceId] = useState("");
    const [deviceType, setDeviceType] = useState(null);
    const [name, setName] = useState("")

    useEffect(() => {
        if (toEditRow != null) {
            setEditMode(true)
            setDeviceCode(toEditRow.deviceCode)
            setDeviceId(toEditRow.deviceId)
            setName(toEditRow.name)
            setSelectedQueue(toEditRow.queue)
            setDeviceType(toEditRow.deviceType)
            setHelpdeskCid(toEditRow.helpdeskCid)
            setSelectedDevices(toEditRow.childDevices.map(el => el.deviceId))
        }

    }, [toEditRow])

    const [loading, setLoading] = useState(false)
    const handleNewDevice = async (e) => {
        e.preventDefault();
        setLoading(true)
        const data =
        {
            "device": {
                "businessId": business,
                name,
                "deviceCode": deviceCode,
                "deviceType": parseInt(deviceType),
                "createDate": moment(new Date()).format('YYYY-MM-DDTHH:mm:ss[Z]'),
                "queue": selectedQueue,
                "HelpdeskCid": helpdeskCid,
                "childDevices": selectedDevices.map((el) => ({
                    DeviceId: el
                }))
            },
            "woltVenueId": selectedWoltVenue,
            password,
            "user": user.username,
        }

        try {
            await axiosInstance.post("/device", data)
            getData()
            setOpen(false)
            setOpenSnackBar(true)
            setSnackbarMsgType({
                message: "Device Added Successfully",
                type: "success"
            })
        } catch (err) {
            console.log(err)
            setOpenSnackBar(true)
            setSnackbarMsgType({
                message: "Error",
                type: "error"
            })
        } finally {
            setLoading(false)
        }
    }
    const handleUpdateDevice = async (e) => {
        e.preventDefault();
        setLoading(true)
        try {

            const data =
            {
                "device": {
                    "deviceId": deviceId,
                    "businessId": business,
                    name,
                    "deviceCode": deviceCode,
                    "deviceType": parseInt(deviceType),
                    "createDate": moment(new Date()).format('YYYY-MM-DDTHH:mm:ss[Z]'),
                    "queue": selectedQueue,
                    "HelpdeskCid": helpdeskCid,
                    "childDevices": selectedDevices.map((el) => ({
                        DeviceId: el
                    }))
                },
                "woltVenueId": selectedWoltVenue,
                password,
                "user": user.username,
            }

            await axiosInstance.put("/device", {
                "deviceId": deviceId,
                "businessId": business,
                name,
                "deviceCode": deviceCode,
                "deviceType": parseInt(deviceType),
                "createDate": moment(new Date()).format('YYYY-MM-DDTHH:mm:ss[Z]'),
                "queue": selectedQueue,
                "HelpdeskCid": helpdeskCid,
                "childDevices": selectedDevices.map((el) => ({
                    DeviceId: el
                }))
            })
            setToEditRow(null)
            getData()
            setOpen(false)
            setOpenSnackBar(true)
            setSnackbarMsgType({
                message: "Device Updated Successfully",
                type: "success"
            })
        } catch (err) {
            console.log(err)
            setOpenSnackBar(true)
            setSnackbarMsgType({
                message: "Cant update this device",
                type: "success"
            })
        } finally {
            setLoading(false)
        }
    }

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedDevices(
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const options = [
        { label: "Device", value: 0 },
        { label: "Wolt", value: 2 },
        { label: "WebOrder", value: 3 },
    ];

    console.log(selectedDevices)

    return (
        <div>
            <Dialog
                fullScreen
                open={true}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>

                        <Button autoFocus variant='contained' color="error" onClick={handleClose}>
                            Close
                        </Button>
                    </Toolbar>
                </AppBar>
                <Box display={"flex"} alignItems={"center"} justifyContent={"center"} flexDirection={"column"} sx={{ height: "100%" }} >
                    <Card sx={{ maxWidth: "600px", p: 3 }}>
                        <Box textAlign={"center"} sx={{ my: 4 }}>
                            <Typography sx={{ fontSize: "24px", fontWeight: 700 }}>{editMode ? "UPDATE" : "CREATE"}  DEVICE</Typography>
                            <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>Te gjitha fushat jane te detyruara!</Typography>
                        </Box>
                        <Grid container spacing={2} >
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box>
                                    <Typography>Deivice name</Typography>
                                    <TextField value={name} size='small' sx={{ width: "100%" }} onChange={e => setName(e.target.value)} />
                                </Box>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box>
                                    <Typography>Helpdesk Cid</Typography>
                                    <TextField value={helpdeskCid} size='small' sx={{ width: "100%" }} onChange={e => setHelpdeskCid(e.target.value)} />
                                </Box>
                            </Grid>

                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box>
                                    <Typography>Deivice Serial</Typography>
                                    <TextField value={deviceCode} size='small' sx={{ width: "100%" }} onChange={e => setDeviceCode(e.target.value)} />
                                </Box>
                            </Grid>

                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box>
                                    <Typography>Device Type</Typography>
                                    <FormControl fullWidth size='small'>
                                        <Select
                                            id="demo-simple-select-type"
                                            value={deviceType}

                                            onChange={e => {
                                                setDeviceType(e.target.value)
                                                if (e.target.value !== 2)
                                                    setSelectedWoltVenue(null);
                                            }}
                                        >
                                            {
                                                options.map((el, i) => {
                                                    return (
                                                        <MenuItem key={el.value} value={el.value}>{el.label}</MenuItem>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                </Box>
                            </Grid>
                            {deviceType === 2 &&
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Box>
                                        <Typography>Wolt venue</Typography>
                                        <FormControl fullWidth size='small' sx={{ mb: 1 }}>
                                            <Select
                                                id="demo-simple-select-type"
                                                value={selectedWoltVenue}
                                                onChange={e => setSelectedWoltVenue(e.target.value)}
                                            >
                                                {currentWoltVenues && currentWoltVenues.length > 0 ?
                                                    currentWoltVenues.map((el, i) => {
                                                        return (
                                                            <MenuItem
                                                                sx={{ display: "flex", flexWrap: "wrap" }}
                                                                key={i}
                                                                value={el.woltVenueId}>
                                                                {el.venueName}
                                                            </MenuItem>
                                                        )
                                                    }) :
                                                    <MenuItem value={""}>No data</MenuItem>

                                                }
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid>
                            }
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box>
                                    <Typography>Devices to Connect</Typography>
                                    <FormControl fullWidth size='small' sx={{ mb: 1 }}>
                                        <Select
                                            id="demo-simple-select-type"
                                            value={selectedDevices}
                                            multiple
                                            onChange={handleChange}
                                        >
                                            {connectedDevices && connectedDevices.length > 0 ?
                                                connectedDevices.map((el, i) => {
                                                    return (
                                                        <MenuItem sx={
                                                            { display: "flex", flexWrap: "wrap" }}
                                                            key={i}
                                                            value={el.deviceId}>
                                                            {el.deviceCode} ({el.name})
                                                        </MenuItem>
                                                    )
                                                }) :
                                                <MenuItem value={""}>No data</MenuItem>

                                            }
                                        </Select>
                                    </FormControl>
                                </Box>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: editMode ? "flex" : "none" }}>
                                <Box>
                                    <Typography>Select a queue</Typography>
                                    <FormControl fullWidth size='small' sx={{ mb: 1 }}>
                                        <TextField
                                            id="demo-simple-select-type"
                                            value={selectedQueue}
                                            onChange={e => setSelectedQueue(e.target.value)}
                                        >
                                        </TextField>
                                    </FormControl>
                                    <Alert severity="info">Select a queue that already exist to add to this device ,
                                        if you dont select a queue a new one will be created.</Alert>
                                </Box>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={"center"}>
                                <Button disabled={loading} onClick={editMode ? handleUpdateDevice : handleNewDevice} color='primary' variant='contained'>
                                    {
                                        loading ? <CircularProgress /> : "RUAJ"
                                    }
                                </Button>
                            </Grid>
                        </Grid>
                    </Card>
                </Box>

            </Dialog>

        </div>
    )
}

export default React.memo(NewDevice, (p, n) => p.business === n.business && p.toEditRow === n.toEditRow && p.user === n.user && p.password === n.password && p.serverExist === n.serverExist)